import pb from './pocketbase.js';
import { BRAND, POCKETBASE_MAIL, POCKETBASE_URL } from '../config.js';

async function postWelcomeMail(payload) {
  const base = POCKETBASE_URL.replace(/\/$/, '');
  const response = await fetch(`${base}${POCKETBASE_MAIL.welcomeRoute}`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: pb.authStore.token,
    },
    body: JSON.stringify(payload),
  });

  let result = {};
  try {
    result = await response.json();
  } catch {
    result = {};
  }

  if (!response.ok) {
    const error = new Error(result.message || `HTTP ${response.status}`);
    error.status = response.status;
    throw error;
  }

  return result;
}

async function sendPasswordResetFallback(email) {
  await pb.collection('users').requestPasswordReset(email);
  return { fallback: 'password_reset' };
}

export async function sendWelcomeMail({ email, name, password, resend = false, userId = '' }) {
  if (!pb.authStore.isValid) {
    throw new Error('Debes iniciar sesión para enviar el correo de bienvenida');
  }

  const normalizedEmail = String(email || '').trim();
  const normalizedUserId = String(userId || '').trim();

  if (!normalizedEmail && !normalizedUserId) {
    throw new Error('Correo o ID de usuario requerido');
  }

  const loginUrl = typeof window !== 'undefined'
    ? `${window.location.origin}/auth/login`
    : '';

  const payload = {
    email: normalizedEmail,
    userId: normalizedUserId,
    name,
    loginUrl,
    mode: resend ? 'resend' : 'create',
    resend: resend ? true : false,
    subjectEmoji: POCKETBASE_MAIL.welcomeSubjectEmoji,
    appName: BRAND.name,
  };

  if (password?.trim()) {
    payload.password = password.trim();
  }

  if (resend) {
    try {
      await postWelcomeMail(payload);
      return { fallback: null };
    } catch (error) {
      console.warn('Reenvío vía hook falló, usando correo nativo de PocketBase:', error);
      let fallbackEmail = normalizedEmail;
      if (!fallbackEmail && normalizedUserId) {
        const record = await pb.collection('users').getOne(normalizedUserId);
        fallbackEmail = (record.email || record.username || '').trim();
      }
      if (!fallbackEmail) {
        throw new Error('No se pudo determinar el correo del usuario');
      }
      return sendPasswordResetFallback(fallbackEmail);
    }
  }

  if (!password?.trim()) {
    throw new Error('Contraseña requerida para el correo de bienvenida');
  }

  try {
    await postWelcomeMail(payload);
    return { fallback: null };
  } catch (error) {
    if (error.status === 404) {
      throw new Error(
        'Ruta de correo no encontrada en PocketBase. Despliega pb_hooks/picking.pb.js en el servidor.'
      );
    }
    throw new Error(error.message || 'No se pudo enviar el correo de bienvenida');
  }
}
